/**
 * Shared Tailwind class fragments for job detail actions (icons, menus, tabs).
 * Uses public jc-* theme from `styles/jc-public-theme.css`.
 */

export const JD_ICON_BTN_BASE =
  'border rounded-full w-11 h-11 flex items-center justify-center shadow-sm transition-[transform,background-color,border-color] duration-200';

export const JD_ICON_BTN_GHOST = `${JD_ICON_BTN_BASE} bg-jc-surface border-jc-border hover:bg-jc-elevated hover:scale-105 active:scale-95 cursor-pointer`;

export const JD_ICON_MUTED = 'text-jc-muted';

/** Saved bookmark when not using company brand colour */
export const JD_SAVE_FILLED_THEME = `${JD_ICON_BTN_BASE} bg-jc-accent-muted border-jc-accent/40 hover:brightness-[0.97] active:scale-95 cursor-pointer`;

export const JD_SAVE_ICON_THEME = 'text-jc-cta';

/** Application pipeline state colours → earth-tone chrome (ellipsis trigger + menu rows). */
export function applicationStateChrome(color: string): { surface: string; icon: string } {
  switch (color) {
    case 'purple':
      return {
        surface:
          'bg-jc-filter-company-bg/80 border-jc-filter-company-border/45 dark:bg-jc-filter-company-bg/50',
        icon: 'text-jc-filter-company-text',
      };
    case 'green':
      return {
        surface: 'bg-jc-accent-muted border-jc-accent/35',
        icon: 'text-jc-accent',
      };
    case 'red':
      return {
        surface:
          'bg-jc-filter-company-bg/60 border-jc-filter-company-border/55 dark:bg-jc-filter-company-bg/40',
        icon: 'text-jc-filter-company-text',
      };
    case 'emerald':
      return {
        surface: 'bg-jc-filter-job-bg border-jc-filter-job-border/45',
        icon: 'text-jc-filter-job-text',
      };
    default:
      return {
        surface: 'bg-jc-filter-salary-bg border-jc-filter-salary-border/40',
        icon: 'text-jc-filter-salary-text',
      };
  }
}

export function applicationStateMenuRowClasses(color: string, isActive: boolean): string {
  const row = 'w-full px-4 py-3 text-left text-sm flex items-center gap-3 transition-colors cursor-pointer';
  const { surface, icon } = applicationStateChrome(color);
  if (isActive) return `${row} ${surface} ${icon} font-medium`;
  return `${row} text-jc-ink-secondary hover:bg-jc-elevated`;
}
